import React, {FunctionComponent} from 'react';
import cn from "classnames";

import './form.scss';

interface IFormHeadingProps {
    className?: string,
}

export const FormHeading: FunctionComponent<IFormHeadingProps> = function ({children, className}) {
    return (
        <div className={cn('formHeading', className)}>
            <div className="formHeading_header">
                {children}
            </div>
            <div className="formHeading_line">
                <div className="formHeading_lineRed"></div>
                <div className="formHeading_lineGrey"></div>
            </div>
        </div>
    );
};